import { ScriptDef, ScriptTheme } from '../../types';

// 喜剧档分片（低分电影·天庭考核办；电影/喜剧荒诞喜剧.md 全量）
export const MOVIE_XIJU_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_108',  // 低分反面教材·电影/低分电影
        name: '天庭考核办',
        genre: 'movie',
        synopsis: '改编自爆款同名漫画，天庭全员编制化！平安巷的门神门安迎来人生第一次年终考核，代理财神赵九斤的年底账上挂着三千笔未兑现香火，新上任的土地苏麦在高层小区里连一个住户都找不到。考核组三人捧着《天庭编制管理办法》，赶在年底大限前疯狂补救。考过，位列仙班；考不过，贬入人间——第一站就是民营公司的苦差事。一个讲规矩的天庭，一群有编制的仙人，一场兵荒马乱的年终大考，就此展开。',
        roles: [
            {
                name: '门安',
                roleType: '男主角',
                billing: 1,
                intro: '平安巷门神，看巷门看了三百年，考编系统上线后白天贴门神帖、晚上背考核手册，春联背面印的都是条例。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '苏麦',
                roleType: '女主角',
                billing: 1,
                intro: '新授土地，辖区是一栋三十二层塔楼，神通出不了小区门，她建了六个业主群，用潜水摸排辖区民意。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '值班星官',
                roleType: '男配角',
                billing: 5,
                intro: '天庭考核办值班星官，神仙下界报备的热线永远由他接，接了三年，没休过一次年假。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Comedy, ScriptTheme.Fantasy],
        heat: 31,
        baseScore: 4.9,
    },
    {
        id: 'SCRIPT_129',  // 电影/喜剧荒诞喜剧
        name: '稳赚不赔',
        genre: 'movie',
        synopsis: '火锅店长牛大有为撑门面租了辆豪车，被街对面的投资机构误认成大老板，尽调电话直接打进了收银台。妻子齐海棠把店里的真本事做成账册应付尽调，职业掮客侯大器闻风而至，负一楼火锅店被包装成明星项目。热潮散去，店还在，汤已经不是原来那锅汤。',
        roles: [
            {
                name: '牛大有',
                roleType: '男主角',
                billing: 1,
                intro: '火锅店长，炒料手艺公认，商业头脑约等于零。糊涂账全记在菜单背面，不敢细算。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '齐海棠',
                roleType: '女主角',
                billing: 1,
                intro: '牛大有的妻子，店里唯一持证会计。尽调电话打来那天，她把菜单背面的账重新装订成册。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '沙青苗',
                roleType: '女配角',
                billing: 3,
                intro: '投资机构分析师，尽调里唯一坚持去后厨看料的人，回去的报告只写了一页。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '闫三盆',
                roleType: '男配角',
                billing: 5,
                intro: '火锅店洗碗工，店里出名后一天被拍十几回，他至今不知道尽调两个字怎么写。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Comedy, ScriptTheme.Urban, ScriptTheme.LifeStyle],
        heat: 50,
        baseScore: 7.8,
    },
    {
        id: 'SCRIPT_130',  // 电影/喜剧荒诞喜剧
        name: '西南小姐',
        genre: 'movie',
        synopsis: '1997年，临江县公关公司经理白四娘办起全县头一届"西南小姐"大赛，为江滨商城攒人气。煤老板乔崇山当场拍下赞助席位，条件只有一个：他的女儿必须加冕。主持人冯雅钱捏着信封知道全部内情，后台的评分表却被人连夜抽走了三页。真正的头号热门是没报名的汽水售货员何六宝——她上台送汽水时被台下起哄推了上去。加冕之夜信封开启，皇冠掉在地上，三方算计当场全部作废。',
        roles: [
            {
                name: '白四娘',
                roleType: '女主角',
                billing: 1,
                intro: '公关公司经理，替地产商办过三场开业典，规约起草得比厂规还厚。大赛的全部家当押在门票钱上。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '何六宝',
                roleType: '女二号',
                billing: 2,
                intro: '商场汽水售货员，被观众起哄推上台的意外选手，决赛那支舞跳的是她每天下班在站台练的广播操变奏。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 2, temperament: 2, talent: 2 },
            },
            {
                name: '乔崇山',
                roleType: '男配角',
                billing: 2,
                intro: '县里头号煤老板，赞助费拍得最响，进场第一件事是让人把评委席挪到看得见他女儿的位置。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
            {
                name: '冯雅钱',
                roleType: '男配角',
                billing: 3,
                intro: '大赛主持人，台词本里夹着两副词，报幕那副是给观众的，报数那副是给后台的。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'wisdom', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { wisdom: 3, temperament: 2 },
            },
            {
                name: '道具房学徒',
                roleType: '男配角',
                billing: 5,
                intro: '文化宫道具房学徒，皇冠和评分表都归他搬，那晚他抱着箱子从侧门出去转了一圈再回来。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'stamina', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { stamina: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Comedy, ScriptTheme.Period],
        heat: 46,
        baseScore: 8.0,
    },
    {
        id: 'SCRIPT_131',  // 电影/喜剧荒诞喜剧
        name: '恩爱夫妻',
        genre: 'movie',
        synopsis: '果贩秦蔓、罗大唐两口子闹到离婚冷静期，经纪公司老板欧飞把他们架进了直播间：一对荧幕恩爱夫妻，三天卖空半个批发市场的枇杷。网友追着喊夫妻本一体，婚庆品牌的代言排到了年后，欧飞把续约合同第一条写成"人设不能崩"。协议签没签字不重要，重要的是今晚八点链接上架，两人要当着十万人互相喂枇杷。',
        roles: [
            {
                name: '秦蔓',
                roleType: '女主角',
                billing: 1,
                intro: '批发市场枇杷档口的一把手，分级一手一个准，开播三年，她一句"家人们"比老公喊得亲；离婚协议压在秤砣底下，秤每天照常开张。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, temperament: 3, talent: 2 },
            },
            {
                name: '罗大唐',
                roleType: '男主角',
                billing: 1,
                intro: '叉车司机兼助播，一百零八条枇杷卖词背得比口诀熟，下播后的口头禅是"关播吧"，打包快递的手上功夫比谁都快。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, talent: 3, temperament: 2 },
            },
            {
                name: '欧飞',
                roleType: '男二号',
                billing: 2,
                intro: '主播经纪公司老板，"恩爱夫妻"是他写的脚本，续约合同第一条熬夜写成"人设不能崩"，每次开会都系这对夫妻结婚那年的红围巾。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
            {
                name: '晚班分拣姑娘',
                roleType: '女配角',
                billing: 5,
                intro: '枇杷仓的夜班分拣员，直播间十万粉丝里有她一个，每晚躲在货堆后头看直播，俩人快递量翻倍，她的计件工资跟着翻倍。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Comedy, ScriptTheme.Urban],
        heat: 32,
        baseScore: 4.8,
    },
];
